import { Col } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { CenteredContentCol, ListHeader, RightContentCol } from "../styles/Styles";
import { MAX_COLS } from "../types/Constants";
import { ColumnAlignment, type EditableListColumnConfig } from "../types/EditableListConfig";
import type { EditableListHeaderProps } from "../types/EditableListHeaderProps";

export const EditableListHeader = (props: EditableListHeaderProps) => {
    const { columns } = props;
    const { t } = useTranslation();

    const calculateFreeSpace = useCallback(() => {
        // @ts-ignore
        const usedCols = columns.map((col) => col.width).reduce((acc, val) => acc + val, 0);
        return Math.max(MAX_COLS - usedCols, 1);
    }, [columns]);

    const createColumn = (column: EditableListColumnConfig) => {
        const key = `${column.field?.name ?? column.field}-${column.title}`;
        if (column.alignment === ColumnAlignment.LEFT) {
            return (
                <Col span={column.width} key={key}>
                    {t(column.title)}
                </Col>
            );
        }
        if (column.alignment === ColumnAlignment.RIGHT) {
            return (
                <RightContentCol span={column.width} key={key}>
                    {t(column.title)}
                </RightContentCol>
            );
        }
        if (column.alignment === ColumnAlignment.CENTER) {
            return (
                <CenteredContentCol span={column.width} key={key}>
                    {t(column.title)}
                </CenteredContentCol>
            );
        }
        return null;
    };

    return (
        <ListHeader>
            {columns?.map(createColumn)}
            <Col span={calculateFreeSpace()}>{t("label.actions")}</Col>
        </ListHeader>
    );
};
